module.exports = __webpack_public_path__ + "img/03.6af2e4d2.png";